export const formatHTML = (text: string) => {
	if (!text) {
		return ''
	}
	return text
		.replace(/<\/b>/g, '\n')
		.replace(/<\/br>/g, '\n')
		.replace(/<\/p>/g, '\n')
		.replace(/(<([^>]+)>)/gi, '')
		.replace(/<p>\s<\/p>/g, '')
		.replace(/&lt;/g, '')
		.replace(/&gt;/g, '')
		.replace(/\t/g, '')
		.replace(/<ol>/g, '')
		.replace(/<\/ol>/g, '')
		.replace(/<li>/g, '')
		.replace(/<\/li>/g, '')
		.replace(/<p>/g, '')
		.replace(/<\/p>/g, '')
		.replace(/<div>/g, '')
		.replace(/<\/div>/g, '')
		.replace(/\r\n\r\n/g, '')
		.replace(/<ul>/g, '')
		.replace(/<\/ul>/g, '')
		.replace(/<br\s*[\/]?>/gi, '')
		.replace(/<span>/g, '')
		.replace(/<\/span>/g, '')
		.replace(/<hr>/g, '')
		.replace(/<\/hr>/g, '')
		.replace(/<b>/g, '')
		.replace(/<\/b>/g, '')
		.replace(/<strong>/g, '')
		.replace(/<\/strong>/g, '')
		.replace(/<pre>/g, '')
		.replace(/<\/pre>/g, '')
		.replace(/&nbsp;/g, ' ')
}